/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EDeviceStatusContactDetails {
  phone = 'Phone',
  email = 'Email'
}
